export const IPEDS_WIZARD_FETCH_SELECT_ITEMS_REQUEST = 'IPEDS_WIZARD_FETCH_SELECT_ITEMS_REQUEST';
export const IPEDS_WIZARD_FETCH_SELECT_ITEMS_SUCCESS = 'IPEDS_WIZARD_FETCH_SELECT_ITEMS_SUCCESS';
export const IPEDS_WIZARD_FETCH_SELECT_ITEMS_FAILURE = 'IPEDS_WIZARD_FETCH_SELECT_ITEMS_FAILURE';

export const IPEDS_WIZARD_SET_ACTIVE_STEP = 'IPEDS_WIZARD_SET_ACTIVE_STEP';
export const IPEDS_WIZARD_SET_EXTRACT = 'IPEDS_WIZARD_SET_EXTRACT';
export const IPEDS_WIZARD_SET_PARAMETER = 'IPEDS_WIZARD_SET_PARAMETER';

export const IPEDS_WIZARD_GENERATE_REPORT_REQUEST = 'IPEDS_WIZARD_GENERATE_REPORT_REQUEST';
export const IPEDS_WIZARD_GENERATE_REPORT_SUCCESS = 'IPEDS_WIZARD_GENERATE_REPORT_SUCCESS';
export const IPEDS_WIZARD_GENERATE_REPORT_FAILURE = 'IPEDS_WIZARD_GENERATE_REPORT_FAILURE';

export const IPEDS_WIZARD_RESET_PARAMETERS = 'IPEDS_WIZARD_RESET_PARAMETERS';
export const IPEDS_WIZARD_RESET = 'IPEDS_WIZARD_RESET';
